import React, { MouseEvent, useMemo, useState } from 'react';
import { WildcardDisplayNames, WildcardValues } from 'shared/enums/WildcardOptions';
import { Tag } from '@televet/kibble-ui/build/components/Tag';

interface IWildcardTagProps {
  value: WildcardValues;
  startIndex: number;
  showPreview: boolean;
  removeWildcard: (value: WildcardValues, startIndex: number) => void;
}

const WildcardTag = ({ value, startIndex, removeWildcard }: IWildcardTagProps): JSX.Element | null => {
  const [isDeleted, setIsDeleted] = useState(false);

  const displayValue = useMemo(() => {
    const keyIndex = Object.values(WildcardValues).indexOf(value);
    const key = Object.keys(WildcardValues)[keyIndex];
    return WildcardDisplayNames[key as keyof typeof WildcardDisplayNames];
  }, [value]);

  const removeTag = (e: MouseEvent): void => {
    e.stopPropagation();
    setIsDeleted(true);
    removeWildcard(value, startIndex);
  };

  return isDeleted ? null : (
    <Tag
      zIndex="1"
      position="relative"
      size="sm"
      label={displayValue}
      closeButtonDisplay="always"
      onClose={removeTag}
      my="2px"
    />
  );
};

export default WildcardTag;
